import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
// import { FaPause } from 'react-icons/fa6';
// import { AtendimentoForms } from '../../components/Hibrido/atendimento-forms';
import { AtendimentoForms } from '../../components/Callback/atendimento-forms';
import { ChatButton } from '../../components/Hibrido/chat-button';
import { Chat } from '../../components/Hibrido/chat';
import { useAuth } from '../../context/AuthContext';
import { useChatWhatsApp } from '../../context/ChatWhatsAppContext';
import { useFila } from '../../context/FilaContext';
import { useDividas } from '../../context/DividasContext';
import { useHibrido } from '../../context/HibridoContext';
import { SwitchButtonLogin } from '../../components/Hibrido/switch-button-login';
import { PhoneOffButton } from '../../components/Hibrido/phone-off-button';
import { ManualButton } from '../../components/Hibrido/manual-button';
import { SelectBreak } from '../../components/Pausas/components/select-breaks';
import { SelectBreakExpert } from '../../components/PausasExpert/components/select-breaks';
import { PauseTime } from '../../components/Pausas/components/pause-time';
import { aplicarMascara } from '../../utils/mascaraTelefone';
import { useModal } from '../../hooks/ModalContext';
import { PauseTimeProvider } from '../../hooks/usePauseTime';
import { GenericModal } from '../../components/Modal';
import { OperadoraProvider } from '../../hooks/OperadoraProvider';
import { SwitchButtonLoginExpert } from '../../components/Hibrido/discador-expert/button-login-expert'
import { PauseTime as PauseTimeExpert } from '../../components/PausasExpert/components/pause-time'
import { PhoneOffButtonExpert } from '../../components/Hibrido/discador-expert/phone-off-expert'
import { SelectOperadora } from '../../components/generics/select-operadora'

interface UsuarioDiscador {
  urlDiscador: string;
  usuarioDiscador: string;
  senhaDiscador: string;
  token3C: string
}


export function Hibrido() {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [operadora, setOperadora] = useState('3C')
  const { validToken, cookies, decodedToken } = useAuth();
  const [, setCookies] = useCookies(['token', 'user', 'whatsapp']);
  const { loginChat } = useChatWhatsApp();
  const { clearSelectedFila } = useFila();
  const { clearDividas } = useDividas();
  const { dadosChamada } = useHibrido();
  const { modalInfo, onClose } = useModal();


  const [usuarioDiscador, setUsuarioDiscador] = useState<UsuarioDiscador | null>(null);

  useEffect(() => {
    clearDividas();
    clearSelectedFila();
  }, []);


  useEffect(() => {
    validToken(cookies?.token);
    if (!cookies?.user) {
      const decoded = decodedToken();
      setCookies('user', {
        id_operador: decoded.id_usuario,
        nome: decoded.nome,
      });
    }
  }, []);

  useEffect(() => {

    const decoded = decodedToken();

    if (decoded.urlDiscador) {
      setUsuarioDiscador({
        urlDiscador: decoded.urlDiscador,
        usuarioDiscador: decoded.usuarioDiscador,
        senhaDiscador: decoded.senhaDiscador,
        token3C: decoded.token3C
      });
    }


  }, [decodedToken]);



  useEffect(() => {
    if (!cookies?.whatsapp) {
      loginChat({ login: '965.773.472-04', password: '123456789' }).then((res) => {
        setCookies('whatsapp', {
          token: res.token,
          queueId: res.queueId,
        });
      });
    }
  }, []);

  return (
    <>
      <OperadoraProvider
        token3C={usuarioDiscador?.token3C || ''}
        socketUrl={usuarioDiscador?.urlDiscador || ''}
        user={usuarioDiscador?.usuarioDiscador || ''}
        password={usuarioDiscador?.senhaDiscador || ''} operadora={operadora}
      >
        <section>
          <div className="m-4 ml-20 mt-10 flex max-h-max flex-grow  flex-col overflow-y-auto ">
            <div className="flex items-center gap-3">
              <div className="flex items-start ">
                <button className="aba w-20 bg-slate-200">Hibrido</button>
              </div>
              <>
                <SelectOperadora operadora={operadora} setOperadora={setOperadora} />

                {
                  operadora === '3C' ? <SwitchButtonLogin /> : <SwitchButtonLoginExpert />
                }


                <div className="flex items-center gap-2 text-sm">
                  <strong className="font-normal text-primary">Telefone Bina: </strong>
                  <p className="">
                    {/* <p className="font-semibold">{dadosChamada?.call?.call_mode === 'dialer' && 'Ligação Receptiva'}</p>{' '} */}
                    {aplicarMascara(dadosChamada?.call?.phone?.replace('55', ''))}
                  </p>
                </div>


                {
                  operadora === '3C' ? <SelectBreak /> : <SelectBreakExpert />
                }
                {
                  operadora === '3C' ? <PhoneOffButton /> : <PhoneOffButtonExpert />
                }

                <ManualButton />

                <PauseTimeProvider>
                  {
                    operadora === '3C' ? <PauseTime /> : <PauseTimeExpert />
                  }

                  <GenericModal
                    title={modalInfo.title}
                    type={modalInfo.type}
                    onClose={() => onClose()}
                    show={modalInfo.isOpen && modalInfo.title === 'Pausas Hibrido'}
                    modalType={operadora === '3C' ? 'Pausas Hibrido' : 'Pausas Hibrido Expert'}
                  />
                </PauseTimeProvider>

                {/* <button onClick={() => setModal('Qualificacao Chamada', 'Qualificacao Chamada', false, false)}>Abrir Modal</button> */}
              </>
            </div>

            <div className="mb-2 flex h-[85vh] w-[74%] items-center justify-center gap-2 rounded-lg border-2 bg-slate-200 px-2 py-2">
              <AtendimentoForms isConsulta />

            </div>

            {!isChatOpen && <ChatButton onClick={() => setIsChatOpen(true)} />}
            <div className="relative">
              <Chat isOpen={isChatOpen} closeSidebar={setIsChatOpen} operadora={operadora} />
            </div>

            <GenericModal
              title={modalInfo.title}
              type={modalInfo.type}
              onClose={() => onClose()}
              show={modalInfo.isOpen && modalInfo.title === 'Buscar Devedor'}
              modalType="Buscar Devedor"
            />


          </div>
        </section>
      </OperadoraProvider>
    </>
  );
}
